
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Menu, X, Gamepad } from 'lucide-react';
import { useIntl } from 'react-intl';

const Header = ({ language, setLanguage }) => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const intl = useIntl();
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const changeLanguage = (newLang) => {
    setLanguage(newLang);
    if (newLang === 'zh' || newLang === 'ko' || newLang === 'es' || newLang === 'fr' || newLang === 'pt' || newLang === 'da' || newLang === 'pl' || newLang === 'ru' || newLang === 'vi' || newLang === 'th' || newLang === 'fil' || newLang === 'ja' || newLang === 'no' || newLang === 'nl' || newLang === 'de' || newLang === 'it' || newLang === 'hi' || newLang === 'ar') {
      navigate(`/${newLang}${location.pathname.replace(/^\/[a-z]{2,3}/, '')}`);
    } else {
      navigate(location.pathname.replace(/^\/[a-z]{2,3}/, ''));
    }
  };

  return (
    <header className="bg-indigo-900 text-white py-4">
      <div className="container mx-auto px-8 flex justify-between items-center">
        <Link to="/" className="text-3xl font-bold">Pokedle</Link>
        <nav className="hidden md:flex space-x-8">
          <Link to="/" className="hover:text-indigo-300">{intl.formatMessage({ id: 'header.home' })}</Link>
          <Link to="/how-to-play" className="hover:text-indigo-300">{intl.formatMessage({ id: 'header.howToPlay' })}</Link>
          <Link to="/pokerogue" className="hover:text-indigo-300 flex items-center">
            <Gamepad className="mr-1 h-4 w-4" />
            <span>PokéRogue</span>
          </Link>
          <Link to="/stickman-hook" className="hover:text-indigo-300 flex items-center">
            <Gamepad className="mr-1 h-4 w-4" />
            <span>Stickman Hook</span>
          </Link>
          <Link to="/monkey-mart" className="hover:text-indigo-300 flex items-center">
            <Gamepad className="mr-1 h-4 w-4" />
            <span>Monkey Mart</span>
          </Link>
          <select value={language} onChange={(e) => changeLanguage(e.target.value)} className="bg-indigo-800 text-white">
            <option value="en">English</option>
            <option value="zh">中文</option>
            <option value="ko">한국어</option>
            <option value="es">Español</option>
            <option value="fr">Français</option>
            <option value="pt">Português</option>
            <option value="da">Dansk</option>
            <option value="pl">Polski</option>
            <option value="ru">Русский</option>
            <option value="vi">Tiếng Việt</option>
            <option value="th">ไทย</option>
            <option value="fil">Filipino</option>
            <option value="ja">日本語</option>
            <option value="no">Norsk</option>
            <option value="nl">Nederlands</option>
            <option value="de">Deutsch</option>
            <option value="it">Italiano</option>
            <option value="hi">हिन्दी</option>
            <option value="ar">العربية</option>
          </select>
        </nav>
        <button className="md:hidden" onClick={toggleMenu}>
          {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      {isMenuOpen && (
        <div className="md:hidden">
          <nav className="flex flex-col items-center space-y-4 py-4">
            <Link to="/" className="hover:text-indigo-300" onClick={toggleMenu}>{intl.formatMessage({ id: 'header.home' })}</Link>
            <Link to="/how-to-play" className="hover:text-indigo-300" onClick={toggleMenu}>{intl.formatMessage({ id: 'header.howToPlay' })}</Link>
            <Link to="/pokerogue" className="hover:text-indigo-300 flex items-center" onClick={toggleMenu}>
              <Gamepad className="mr-1 h-4 w-4" />
              <span>PokéRogue</span>
            </Link>
            <Link to="/stickman-hook" className="hover:text-indigo-300 flex items-center" onClick={toggleMenu}>
              <Gamepad className="mr-1 h-4 w-4" />
              <span>Stickman Hook</span>
            </Link>
            <Link to="/monkey-mart" className="hover:text-indigo-300 flex items-center" onClick={toggleMenu}>
              <Gamepad className="mr-1 h-4 w-4" />
              <span>Monkey Mart</span>
            </Link>
            <select value={language} onChange={(e) => changeLanguage(e.target.value)} className="bg-indigo-800 text-white">
              <option value="en">English</option>
              <option value="zh">中文</option>
              <option value="ko">한국어</option>
              <option value="es">Español</option>
              <option value="fr">Français</option>
              <option value="pt">Português</option>
              <option value="da">Dansk</option>
              <option value="pl">Polski</option>
              <option value="ru">Русский</option>
              <option value="vi">Tiếng Việt</option>
              <option value="th">ไทย</option>
              <option value="fil">Filipino</option>
              <option value="ja">日本語</option>
              <option value="no">Norsk</option>
              <option value="nl">Nederlands</option>
              <option value="de">Deutsch</option>
              <option value="it">Italiano</option>
              <option value="hi">हिन्दी</option>
              <option value="ar">العربية</option>
            </select>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
